// File: PartnershipFirmTaxReturnFiling.jsx
import React from "react";

export default function PartnershipFirmTaxReturnFiling() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Partnership Firm Tax Return Filing
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in accurate tax return filing for partnership firms.
          </p>
          <p className="text-gray-700">
            Complete ITR-5 e-filing including audit report coordination (Form 3CD), partner remuneration/salary calculations, interest on capital deductions, balance sheet preparation, profit sharing ratio verification, and Income Tax portal compliance.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Partnership firm tax return filing India) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Partnership firm tax return filing compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless partnership firm tax filing.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Books of accounts and financial ledgers</li>
                <li>PAN of partnership firm and partners</li>
                <li>Financial statements (Balance Sheet, P&L)</li>
                <li>Bank statements and audit reports (if applicable)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Tax accuracy and compliance focus for partnership firm ITR filing requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  ITR-5 E-Filing Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete ITR-5 preparation with accurate partner remuneration (Section 40(b)), interest on capital deductions (upto 12%), Form 3CD audit report e-filing, balance sheet schedules, profit computation, and Income Tax portal DSC/EVC verification ensuring error-free submission.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Tax Audit Compliance (Section 44AB)
                </h3>
                <p className="text-gray-700 text-sm">
                  Mandatory audit management for turnover > ₹1 Cr (business) or > ₹50 Lakh (profession), Form 3CD preparation, audit report upload by 30th September, tax audit clause verification, partner-wise profit allocation, and advance tax compliance preventing scrutiny notices and penalties.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Tax Optimization
                </h3>
                <p className="text-gray-700 text-sm">
                  Full tax planning services including 30% flat tax optimization, surcharge calculation (>₹1 Cr), 4% cess computation, partner remuneration limits (₹3L or 90% profits), interest deductions, depreciation claims, TDS compliance, and refund processing with maximum tax savings.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
